import appMarketAggregator from '@/modules/appMarket/utils/appMarketAggregator';

let inFlightPromise = null;

const state = {
  apps: [],
  loaded: false,
};

const getters = {
  marketApps: (state) => state.apps,
  marketAppsLoaded: (state) => state.loaded,
  visibleMarketApps: (state) => state.apps.filter((app) => app.is_listed),
  marketAppByCodeName: (state) => (appCodeName) => state.apps.find((app) => app.app_code_name === appCodeName),
};

const mutations = {
  setApps(state, apps) {
    state.apps = apps;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
};

const actions = {
  async fetchMarketApps({
    state, commit, dispatch, rootGetters,
  }, { force = false } = {}) {
    if (state.loaded && !force) return state.apps;
    if (inFlightPromise && !force) return inFlightPromise;

    const promise = (async () => {
      try {
        await dispatch('AppsStore/loadApps', undefined, { root: true });
        await dispatch('AccountStore/getAccountCurrency', null, { root: true });
        const [offerings] = await Promise.all([
          dispatch('OfferingStore/fetchAppOfferings', undefined, { root: true }),
          dispatch('SubscriptionStore/fetchActiveSubscriptions', undefined, { root: true }),
        ]);

        const apps = appMarketAggregator.aggregateMarketApps({
          apps: rootGetters['AppsStore/marketApps'].map((app) => ({ ...app })),
          offerings,
          subscriptions: rootGetters['SubscriptionStore/activeSubscriptions'],
          geoData: rootGetters['AccountStore/geoData'],
        });

        commit('setApps', apps);
        commit('setLoaded', true);
        return apps;
      } finally {
        if (inFlightPromise === promise) inFlightPromise = null;
      }
    })();

    inFlightPromise = promise;
    return promise;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
